let _id = 0;

module.exports = function generateId() {
  return `simplepostmd-editor-${++_id}`;
}



// WEBPACK FOOTER //
// ./src/services/idGenerator.js


// WEBPACK FOOTER //
// webpack:///src/services/idGenerator.js